// import adaptPad from "../utils/adaptPad";
import StaHistory from "../utils/StaHistory";
import { addWindowQueue, getEnv, setScreen, setVars } from "../utils/tools";

export default function () {
  addWindowQueue("resizeEvent");
  setVars();
  setScreen();
  // adaptPad();
  getEnv();
  const staHistory = new StaHistory();

  return {
    staHistory,
  };
}
